var ChargeBookingsController = /** @class */ (function () {
    function ChargeBookingsController($scope, $state, chargeBookingsService, $loading, $mdDialog, $translationService, AuthService) {
        this.$scope = $scope;
        this.$state = $state;
        this.chargeBookingsService = chargeBookingsService;
        this.$loading = $loading;
        this.$mdDialog = $mdDialog;
        this.$translationService = $translationService;
        this.AuthService = AuthService;

        this.items = [];
        this.ready = false;
        $scope.vm = this;        

        // NF-806: hide km
        this.hideAutonomyEstimation = false;

        this.$element = $('#internal-charge-bookings');
        this.onInit();
    }
    Object.defineProperty(ChargeBookingsController.prototype, "ChargeBookingStatus", {
        get: function () {
            return ChargeBookingStatus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChargeBookingsController.prototype, "ChargeBookingDateType", {
        get: function () {
            return ChargeBookingDateType;
        },
        enumerable: false,
        configurable: true
    });
    ChargeBookingsController.prototype.onInit = function () {
        var _this = this;

        // NF-806
        var user = this.AuthService.getAuthenticatedUser();        
        if (user) {
            this.hideAutonomyEstimation = user.HideAutonomyEstimationForChargeOnMobile;
        }

        this.refresh().then(function () {
            _this.ready = true;
        });
    };
    /**
     * Go to prev history
     */
    ChargeBookingsController.prototype.back = function () {
        this.$state.go('internal.home');
    };
    /**
     * Do refresh when pull to down to refresh
     */
    ChargeBookingsController.prototype.doRefresh = function () {
        var _this = this;
        this.refresh().then(function () {
            // Hide refresh button
            _this.$scope.$broadcast('scroll.refreshComplete');
        });
    };
    /**
     * Trigger when click on delete button to delete a charge booking
     * Show confirm before delete a charge booking
     * @param {IChargeBooking} item
     * @param {MouseEvent} $event
     */
    ChargeBookingsController.prototype.onChargeBookingDelete = function (item, $event) {
        var _this = this;
        $event.stopImmediatePropagation();
        this.chargeBookingsService.showConfirmDeleteChargeBooking($event).then(function () {            
            _this.$loading.show();
            _this.chargeBookingsService.deleteChargeBooking(item.Id)
                .finally(function () {
                _this.$loading.hide();
            })
                .then(function () {
                _this.refresh();
            });
        });
    };
    /**
     * Connect vehicle with charge booking
     * @param item
     * @param $event
     */
    ChargeBookingsController.prototype.onChargeBookingConnect = function (item, $event) {
        var _this = this;
        $event.stopImmediatePropagation();
        this.chargeBookingsService.CheckIfReadyToBeConnected(item.Id).then(function () {
            _this.$state.go('internal.chargingrequest', { context: "chargebooking", contextId: item.Id });
        });
    };
    /**
     * Trigger when click on + button to show vehicle and to edit mode
     * @param ev
     */
    ChargeBookingsController.prototype.onAddChargeBookingClick = function (ev) {
        var _this = this;
        this.$loading.show();
        this.chargeBookingsService.getVehicles()
            .finally(function () {
            _this.$loading.hide();
        })
            .then(function (vehicles) {
            if (vehicles.length === 0) {
                var msg = _this.$translationService.getTranslation('CannotAddChargeBookingBecauseNoEV');
                var alert_1 = _this.$mdDialog.alert()
                    // .textContent('You cannot create a charge booking because you do not have any electric vehicle (full EV) assigned to you.')
                    .textContent(msg)
                    .ok(_this.$translationService.getTranslation('OK'))
                    .targetEvent(ev)
                    .clickOutsideToClose(true);
                _this.$mdDialog.show(alert_1);
            } else if (vehicles.length === 1) {
                var params = {
                    state: JSON.stringify({
                        vehicle: vehicles[0]
                    })
                };
                _this.$state.go('internal.chargebooking', params);
            } else if (vehicles.length > 1) {
                _this.showVehicleModal(vehicles).then(function (vehicle) {
                    var params = {
                        state: JSON.stringify({
                            vehicle: vehicle
                        })
                    };
                    _this.$state.go('internal.chargebooking', params);
                });
            }
        });
    };
    /**
     * Trigger when click on item to edit/view details charge booking
     * @param item
     */
    ChargeBookingsController.prototype.onItemClick = function (item) {
        var params = {
            id: item.Id,
            state: JSON.stringify({
                vehicle: {
                    Id: item.VehicleId,
                    Model: item.VehicleModel,
                    Name: item.VehicleName
                },
                item: item
            })
        };
        this.$state.go('internal.chargebooking', params);
    };
    /**
     * Get charge bookings from serve
     * @private
     */
    ChargeBookingsController.prototype.getChargeBookings = function () {
        return this.chargeBookingsService.getChargeBookings().then(function (items) {
            items.forEach(function (item) {
                item.type = ChargeBookingDateType.Customize;
                if (item.StartDate === item.EndDate) {
                    item.type = ChargeBookingDateType.SameDay;
                    if (item.StartTime === '00:00' && item.EndTime === '23:59') {
                        item.type = ChargeBookingDateType.FullDay;
                    }
                }
            });
            return items;
        });
    };
    /**
     * Refresh data
     * @private
     */
    ChargeBookingsController.prototype.refresh = function () {
        var _this = this;
        return this.getChargeBookings().then(function (items) {
            _this.items = items;
        });
    };
    /**
     * Show vehicles modal when click on plus button
     * @param vehicles
     * @private
     */
    ChargeBookingsController.prototype.showVehicleModal = function (vehicles) {
        return this.$mdDialog.show({
            controller: VehiclesModalController,
            controllerAs: 'vm',
            templateUrl: 'js/internal/vehicles/vehicles-modal.view.html',
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            escapeToClose: true,
            locals: {
                vehicles: vehicles,
                options: {
                    contextMessage: this.$translationService.getTranslation('WhichVehicleWillYouDrive')
                }
            }
        });
    };
    ;
    ChargeBookingsController.$inject = ['$scope', '$state', 'ChargeBookingsService', '$Loading', '$mdDialog', '$translationService', 'AuthService'];
    return ChargeBookingsController;
}());
